import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=55c9a20d"
import script from "./Footer.vue?vue&type=script&lang=scss"
export * from "./Footer.vue?vue&type=script&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports